import { statusSituation } from '../helpers/enum';

export default (history, item, location) => {
  let status = statusSituation[item.estado.estado];

  if(item.solicitudExcepciones) {
    return history.push({
      pathname: '/admin/detail-exception',
      idCredit: item.id,
      idExcepcionSolicitud: item?.solicitudExcepciones?.id
    });
  }

  if(location.pathname === '/admin/pendientes_identidad'){
    return history.push({
      pathname: '/admin/validacion_identidad',
      item: item
    });
  }

  if(!status) {
    return history.push('/admin/dashboard');
  }

  if(location.pathname === '/admin/pendientes_adjuntar'){
    return history.push({
      pathname: '/admin/adjuntar_documentos',
      item: item
    });
  }

  var historyData = {};

  if(item.idSimulacion) {
    historyData = {
      ...historyData,
      idSimulation: item.idSimulacion
    }
  }

  if(item.cliente && item.cliente.id && item.cliente.identificacion && item.cliente.tipoIdentificacion) {
    historyData = {
      ...historyData,
      client: {
        id: item.cliente.id,
        identification: item.cliente.identificacion,
        identificationType: item.cliente.tipoIdentificacion
      }
    }
  }
  
  historyData = {
    ...historyData,
    idCredit: item.id,
    step: status.step,
    conformity: status.conformity,
    validating: status.validating,
    alertComplience: status.alertComplience,
    validatingComplience: status.validatingComplience
  };

  historyData.pathname = status.pathname;
  return history.push(historyData);
}
